export const initialState = {
  profileInfo: {
    user: {},
    touchPoints: [],
    ranking: null,
    rankingStage: {},
    rankingPosition: null,
  },
  profile: null,
  notifications: null,
  unseenNotificationsCount: null,
  tasks: {
    current: [],
    ended: [],
    featuredTask: null,
  },
  wheelPoints: null,
  wheelPointsAnimationVisible: false,
  selectedUserId: null,
};

export const isAuthenticated = (state = initialState) => state.profile || initialState.profile;
